// extracted by mini-css-extract-plugin
export default {"styledNav":"Nav_styledNav__I5c4C","Nav":"Nav_Nav__a+ptN","brand":"Nav_brand__ZjEQr","myName":"Nav_myName__r9uAm","navItems":"Nav_navItems__9qNc0","resume":"Nav_resume__wn7sU"};